export function showHidePanelPortfolio (element) {
  element.unbind('click', null)

  let handler = function (event) {
    event.preventDefault()
    let hpanel = $(this).closest('div.hpanel')
    let icon = $(this).find('i:first')
    let body = hpanel.find('div.panel-body.portfolio')
    let footer = hpanel.find('div.panel-footer.portfolio')
    let projects = hpanel.find('div.panel-projects.portfolio')

    body.slideToggle(300)
    footer.slideToggle(200)
    projects.slideToggle(200)

    // Toggle icon from up to down
    icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down')
    hpanel.toggleClass('').toggleClass('panel-collapse')

    setTimeout(function () {
      hpanel.resize()
      hpanel.find('[id^=map-]').resize()
    }, 50)
  }

  element.on('click', handler)
}


export function hashCode (str) {
  let hash = 0
  let i
  let chr
  let len

  if (str.length === 0) { return hash }
  for (i = 0, len = str.length; i < len; i++) {
    chr = str.charCodeAt(i)
    hash = ((hash << 5) - hash) + chr
    hash |= 0 // Convert to 32bit integer
  }
  return hash
}

export function convertHex (color, opacity) {
  color = color.replace('#', '')
  let r = parseInt(color.substring(0, 2), 16)
  let g = parseInt(color.substring(2, 4), 16)
  let b = parseInt(color.substring(4, 6), 16)
  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')'
}


// WEBPACK FOOTER //
// ./src/assets/scripts/utils.js